export default function IconCar(props) {
  return (
    <svg
      width="62"
      height="62"
      viewBox="0 0 62 62"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}>
      <mask
        id="mask0_45_1509"
        style={{ maskType: "alpha" }}
        maskUnits="userSpaceOnUse"
        x="0"
        y="0"
        width="62"
        height="62">
        <rect width="62" height="62" fill="white" />
      </mask>
      <g mask="url(#mask0_45_1509)">
        <path
          d="M13.5124 46.5V50.375C13.5124 50.741 13.3887 51.0477 13.1411 51.2953C12.8935 51.5429 12.5868 51.6667 12.2208 51.6667H11.6247C11.2587 51.6667 10.9519 51.5429 10.7044 51.2953C10.4568 51.0477 10.333 50.741 10.333 50.375V31.3972L15.4596 16.7917C15.5858 16.3809 15.8284 16.063 16.1875 15.8378C16.547 15.6126 16.947 15.5 17.3874 15.5H44.8108C45.2018 15.5 45.5568 15.6184 45.8758 15.8552C46.1948 16.092 46.4161 16.4042 46.5397 16.7917L51.6663 31.3972V50.375C51.6663 50.741 51.5426 51.0477 51.295 51.2953C51.0474 51.5429 50.7406 51.6667 50.3747 51.6667H49.7786C49.4126 51.6667 49.1058 51.5429 48.8583 51.2953C48.6107 51.0477 48.4869 50.741 48.4869 50.375V46.5H13.5124ZM13.9897 28.8139H48.0096L44.2044 18.0833H17.795L13.9897 28.8139ZM19.1874 40.5383C19.9912 40.5383 20.6704 40.2572 21.225 39.6949C21.78 39.1321 22.0575 38.449 22.0575 37.6456C22.0575 36.8418 21.7761 36.1626 21.2134 35.608C20.6511 35.053 19.968 34.7755 19.1641 34.7755C18.3607 34.7755 17.6815 35.0569 17.1265 35.6196C16.572 36.182 16.2947 36.865 16.2947 37.6689C16.2947 38.4723 16.5758 39.1515 17.1382 39.7065C17.7009 40.261 18.384 40.5383 19.1874 40.5383ZM42.8352 40.5383C43.6386 40.5383 44.3178 40.2572 44.8728 39.6949C45.4274 39.1321 45.7047 38.449 45.7047 37.6456C45.7047 36.8418 45.4235 36.1626 44.8612 35.608C44.2985 35.053 43.6154 34.7755 42.812 34.7755C42.0081 34.7755 41.3289 35.0569 40.7744 35.6196C40.2194 36.182 39.9419 36.865 39.9419 37.6689C39.9419 38.4723 40.2233 39.1515 40.786 39.7065C41.3483 40.261 42.0314 40.5383 42.8352 40.5383ZM12.9163 43.9167H49.083V31.3972H12.9163V43.9167Z"
          fill="currentColor"
        />
      </g>
    </svg>
  );
}
